import store_analyse from '@/store/mods/clinique/analyses'
import $ from 'jquery'

export default {
    name: 'l-analyse',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            categories_analyses: [],
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
        }
    },
    
    computed: {

    },

    mounted() {
        this.fetchCategoriesAnalyses();
    },

    methods: {
        fetchCategoriesAnalyses() {
            this.is_loading = true;
            this.is_load_error = false;
            store_analyse.getCategoriesAnalyse().then((response) => {
                this.categories_analyses = response

                if (this.categories_analyses.length === 0) {
                    this.is_empty = true;
                } else {
                    this.is_empty = false;
                }

                this.is_loading = false;
            }).catch(() => {
                this.is_loading = false;
                this.is_load_error = true
            });
        },

        toutSelectionner() {
            let is_checked = $('#analyse-tous').is(":checked")

			this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.categories_analyses.forEach((categorie_analyse) => {
                if (is_checked) {
                    this.each_cat_is_checked.push(categorie_analyse.id)
                }

                categorie_analyse.analyses.forEach((analyse) => {
                    if (is_checked) {
                        this.one_is_checked.push({id: analyse.id, libelle: analyse.nom})
                    }
                })
            });
            
            this.all_checked = is_checked
        },

		/**
		 * Sélectionner / Déselectionner une catégorie d'analyse
		 */
		touteCategorie(index) {
			let is_checked = $('#cat-tous'+index).is(":checked")
			this.toggleCategorieChecked(is_checked, index)
		},

		toggleCategorieChecked(is_checked, index) {
            this.categories_analyses.forEach((categorie_analyse) => {
                if (categorie_analyse.id == index) {
                    if (is_checked) {
                        // remove all analyses of this category from one_is_checked
                        this.one_is_checked = this.one_is_checked.filter((analyse) => {
                            return !categorie_analyse.analyses.some((a) => a.id === analyse.id)
                        })
                    }

                    categorie_analyse.analyses.forEach((analyse) => {
                        if (is_checked) {
                            this.one_is_checked.push({id: analyse.id, libelle: analyse.nom})
                        } else {
                            this.one_is_checked = this.one_is_checked.filter((analyse) => {
                                return !categorie_analyse.analyses.some((a) => a.id === analyse.id)
                            })
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },
    }
}